// extracted by mini-css-extract-plugin
module.exports = {"title":"Collection_title__1qNnD","cardList":"Collection_cardList__3sBy_"};